import React, { useEffect } from "react";
import { useNavigate, NavLink, Outlet, useLocation } from "react-router-dom";

const SuperAdmin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";
    if (!isSuperAdmin) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const navItemClass = (active: boolean) =>
    `flex items-center gap-3 px-4 py-2 rounded-lg transition border ${
      active
        ? "bg-white/5 border-[#B59143] text-white"
        : "bg-transparent border-transparent text-[#C3C9D3] hover:bg-white/5 hover:text-white"
    }`;

  return (
    <div className="min-h-screen bg-[#0B0B0F] text-white flex">
      {/* Sidebar */}
      <aside className="w-64 hidden md:flex flex-col gap-4 p-4 border-r border-[#2E2F33] sticky top-0 h-screen">
        <div className="mb-2">
          <h1 className="text-xl font-bold">
            <span className="bg-clip-text text-transparent" style={{
              background: "linear-gradient(90deg, #FBD282, #B59143)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}>Zen</span>
            <span className="text-white">Sight</span>
          </h1>
          <p className="text-[#C3C9D3] text-sm">Super Admin</p>
        </div>

        <nav className="flex flex-col gap-2">
          <NavLink to="/superadmin" end className={({ isActive }) => navItemClass(isActive)}>
            <span className="inline-block w-2 h-2 rounded-full bg-[#FBD282]"></span>
            Dashboard
          </NavLink>
          <NavLink to="/superadmin/organizations" className={({ isActive }) => navItemClass(isActive)}>
            <span className="inline-block w-2 h-2 rounded-full bg-[#B59143]"></span>
            Organizations
          </NavLink>
        </nav>

        <div className="mt-auto">
          <button
            className="w-full px-4 py-2 rounded-lg bg-[#1A1C1F] border border-[#2E2F33] hover:border-[#B59143] hover:shadow-[0_0_12px_rgba(181,145,67,0.25)] transition"
            onClick={() => {
              localStorage.removeItem("isSuperAdmin");
              window.dispatchEvent(new Event("superAdminStatusChanged"));
              // Use window.location for reliable navigation outside nested routes
              // This ensures the route is properly matched at the root level
              window.location.href = "/login";
            }}
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="border-b border-[#2E2F33] sticky top-0 bg-[#0B0B0F]/80 backdrop-blur">
          <div className="mx-auto px-4 py-4 flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-[#E8C16C]">
                {location.pathname.includes("organizations") ? "Organizations" : "Dashboard"}
              </h2>
              <p className="text-[#C3C9D3] text-sm">
                {location.pathname.includes("organizations")
                  ? "All registered organizations in the system"
                  : "Overview of platform metrics"}
              </p>
            </div>
          </div>
        </header>

        <main className="mx-auto p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SuperAdmin;


